import { testimonials } from '@/mocks/siteData';

const stats = [
  { value: '2,400+', label: '累计整理条目' },
  { value: '98%', label: '进展当日更新' },
  { value: '5 大', label: '话题分类板块' },
  { value: '12 项', label: '信源交叉核验' },
];

export default function Testimonials() {
  return (
    <section className="w-full px-4 py-12 md:px-6 md:py-16" aria-labelledby="voice-title">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-3">
        <div className="lg:col-span-1">
          <span className="font-label text-xs font-medium uppercase tracking-widest text-primary-600">
            瓜友口碑
          </span>
          <h2 id="voice-title" className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            围观群众怎么说
          </h2>
          <p className="mt-3 font-body text-sm leading-relaxed text-foreground-600">
            我们把“已确认”和“待核实”分开标注，尽量让每一条进展都经得起回看。下面是常来看看的瓜友留下的评价。
          </p>
          <dl className="mt-8 grid grid-cols-2 gap-5">
            {stats.map((stat) => (
              <div key={stat.label} className="rounded-lg border border-background-200 bg-background-50 p-4">
                <dt className="font-heading text-2xl font-bold text-primary-600">{stat.value}</dt>
                <dd className="mt-1 font-label text-xs text-foreground-600">{stat.label}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="flex flex-col gap-4 lg:col-span-2">
          {testimonials.map((item) => (
            <blockquote
              key={item.name}
              className="flex flex-col gap-4 rounded-lg border border-background-200 bg-background-100 p-5 md:flex-row md:p-6"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-800">
                <i className="ri-double-quotes-l text-xl"></i>
              </span>
              <div>
                <p className="font-body text-sm leading-relaxed text-foreground-800 md:text-base">{item.text}</p>
                <footer className="mt-3 flex items-center gap-3">
                  <span className="font-heading text-sm font-semibold text-foreground-950">{item.name}</span>
                  <span className="font-label text-xs text-foreground-500">{item.role}</span>
                </footer>
              </div>
            </blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}